import { Button } from '../molecules/buttons/button'
import { useTranslation } from 'react-i18next';
import { getEmojiFlag } from 'countries-list'
import { languages } from 'countries-list'
import { useToast } from './feedback/use-toast';
import { useUpdateProfile } from '@/services/consultant-services/mutation/useUpdateProfile';
import {useAppSelector} from '@/store/hooks.js';
import store from '@/store/store.js';
import {updateUserFields} from '@/store/slices/authSlice.js';

export default function Translate() {
    const { i18n } = useTranslation("global");
    const user = useAppSelector((state) => state.auth.currentUser);
    const currentLanguage = user.language.toUpperCase();
    const { setLanguage } = useUpdateProfile();
    const { toast } = useToast();
    const handleUpdateLanguage = async (newLanguage) => {
        i18n.changeLanguage(newLanguage.toLowerCase())
        const { error } = await setLanguage(newLanguage.toUpperCase());
        if (error) {
            console.error('handleUpdateLanguage Error updating language:', error);
            toast({
                variant: "error",
                title: "error.requestFailed",
                duration: 2500,
                message: error
            })
            return error;
        } else {
            store.dispatch(updateUserFields({ language: newLanguage }));
            return undefined;
        }
    };

    return (

        <div className='flex rounded-sm overflow-hidden w-full'>

            <Button
                showText={true}
                style={currentLanguage === "EN" ? `dressedGhost` : `ghost`}
                className="rounded-none w-full"
                onClick={() => handleUpdateLanguage("en")}>
                {getEmojiFlag("GB")} {languages.en.native}
            </Button>

            <Button
                showText={true}
                style={currentLanguage === "FR" ? `dressedGhost` : `ghost`}
                className="rounded-none w-full"
                onClick={() => handleUpdateLanguage("fr")}>
                {getEmojiFlag("FR")} {languages.fr.native}
            </Button>

        </div>
    )
}
